<script setup lang="ts">
import { computed } from 'vue'
import { DISTRIBUTE_ANCHOR_LABEL } from '@/constants/distribute'
import { buildVideoFirstFrameUrl } from '@/utils/distribute/media-url'
import CoverMetaOverlay from '@/components/distribute-cover-meta-overlay'
import HoverVideo from '@/components/distribute-hover-video'
import type { Emits, Props, VideoOverlayState } from './type'

defineOptions({
  name: 'DistributeVideoCard',
})

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const primaryAnchor = computed(() =>
  props.variant === 'media' ? (props.model.item.anchors?.[0] ?? null) : null,
)
const posterUrl = computed(() => {
  if (props.model.previewVideoCoverUrl) {
    return props.model.previewVideoCoverUrl
  }

  if (buildVideoFirstFrameUrl(props.model.previewVideoUrl)) {
    return null
  }

  return props.model.coverUrl
})
const overlayState = computed<VideoOverlayState>(() => {
  if (props.variant === 'pipe') {
    return {
      anchor: null,
      showAnchor: true,
      anchorLabel: DISTRIBUTE_ANCHOR_LABEL,
      showBgm: false,
    }
  }

  return {
    anchor: primaryAnchor.value,
    showAnchor: props.model.item.anchorStyle === 'big_center' && Boolean(primaryAnchor.value),
    anchorLabel: DISTRIBUTE_ANCHOR_LABEL,
    showBgm: props.model.kind === 'media-mv',
  }
})

function handlePreviewReady() {
  emit('preview-ready')
}
</script>

<template>
  <HoverVideo
    :src="model.previewVideoUrl"
    :poster="posterUrl"
    :aspect-ratio="model.aspectRatio"
    :label="model.label"
    :media-width="mediaWidth"
    :priority="priority"
    :autoplay-active="autoplayActive"
    @preview-ready="handlePreviewReady"
  >
    <CoverMetaOverlay
      :model="model"
      :anchor="overlayState.anchor"
      :show-anchor="overlayState.showAnchor"
      :anchor-label="overlayState.anchorLabel"
      :show-bgm="overlayState.showBgm"
      :require-login="requireLogin"
      @login="$emit('login')"
    />
  </HoverVideo>
</template>
